import React from 'react';
import { Building2, Award } from 'lucide-react';
export function Clients() {
  const clients = [{
    name: 'Edo State Government',
    logo: '🏛️',
    sector: 'Government'
  }, {
    name: 'Presidential Amnesty Program',
    logo: '🎓',
    sector: 'Government'
  }, {
    name: 'Nigerian Investment Promotion Commission',
    logo: '💼',
    sector: 'Government'
  }, {
    name: 'Myma Foods',
    logo: '🍽️',
    sector: 'Food & Beverage'
  }, {
    name: 'AutoByte Limited',
    logo: '🚗',
    sector: 'Automotive'
  }, {
    name: 'Dmayo Photography',
    logo: '📸',
    sector: 'Creative Services'
  }, {
    name: 'Isonyin Grammar School',
    logo: '🎓',
    sector: 'Education'
  }, {
    name: 'FDF Gold',
    logo: '💎',
    sector: 'Mining & Resources'
  }, {
    name: 'Senator Fatimat Raji Rasaki Foundation',
    logo: '🤝',
    sector: 'Non-Profit'
  }, {
    name: 'BlackBit Group',
    logo: '🔷',
    sector: 'Technology'
  }, {
    name: 'SMX Africa',
    logo: '🌍',
    sector: 'Technology'
  }];
  return <div className="min-h-screen bg-white pt-20" data-id="element-250">
      {/* Hero Section with Beautiful Header Image */}
      <section className="relative py-20 sm:py-32 bg-gradient-to-br from-slate-900 to-blue-900 text-white overflow-hidden" data-id="element-251">
        <div className="absolute inset-0 opacity-30" data-id="element-252">
          <img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=2000&auto=format&fit=crop" alt="Black business professionals in partnership meeting" className="w-full h-full object-cover" data-id="element-253" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 to-blue-900/80" data-id="element-254" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 text-center" data-id="element-255">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/20 border border-blue-400/30 rounded-full mb-6" data-id="element-256">
            <Award className="w-4 h-4" data-id="element-257" />
            <span className="text-sm font-bold" data-id="element-258">
              Trusted by Leading Organizations
            </span>
          </div>
          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black mb-6" data-id="element-259">
            Our Clients
          </h1>
          <p className="text-lg sm:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed" data-id="element-260">
            We're proud to partner with forward-thinking organizations across
            government, enterprise, and emerging sectors
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 sm:py-16 bg-slate-50" data-id="element-261">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-262">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 text-center" data-id="element-263">
            <div data-id="element-264">
              <div className="text-3xl sm:text-4xl font-black text-blue-600 mb-2" data-id="element-265">
                50+
              </div>
              <div className="text-xs sm:text-sm font-bold text-slate-600" data-id="element-266">
                Active Clients
              </div>
            </div>
            <div data-id="element-267">
              <div className="text-3xl sm:text-4xl font-black text-cyan-600 mb-2" data-id="element-268">
                95%
              </div>
              <div className="text-xs sm:text-sm font-bold text-slate-600" data-id="element-269">
                Satisfaction Rate
              </div>
            </div>
            <div data-id="element-270">
              <div className="text-3xl sm:text-4xl font-black text-indigo-600 mb-2" data-id="element-271">
                130+
              </div>
              <div className="text-xs sm:text-sm font-bold text-slate-600" data-id="element-272">
                Projects Delivered
              </div>
            </div>
            <div data-id="element-273">
              <div className="text-3xl sm:text-4xl font-black text-purple-600 mb-2" data-id="element-274">
                12+
              </div>
              <div className="text-xs sm:text-sm font-bold text-slate-600" data-id="element-275">
                Years Partnership
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Clients */}
      <section className="py-12 sm:py-20" data-id="element-276">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-277">
          <div className="text-center mb-12 sm:mb-16" data-id="element-278">
            <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-279">
              Featured Clients
            </h2>
            <p className="text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto" data-id="element-280">
              Organizations that trust us with their digital transformation
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16" data-id="element-281">
            {clients.slice(0, 6).map((client, index) => <FeaturedClientCard key={index} client={client} data-id="element-282" />)}
          </div>

          <div className="text-center mb-8 sm:mb-12" data-id="element-283">
            <h3 className="text-xl sm:text-2xl font-black text-slate-900 mb-8" data-id="element-284">
              Other Valued Clients
            </h3>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6" data-id="element-285">
            {clients.slice(6).map((client, index) => <ClientLogoCard key={index} client={client} data-id="element-286" />)}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-12 sm:py-20 bg-slate-50" data-id="element-287">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-288">
          <div className="text-center mb-12 sm:mb-16" data-id="element-289">
            <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-290">
              What Our Clients Say
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-291">
            <TestimonialCard quote="Manuel Technologies delivered beyond our expectations. Their expertise in government digitization is unmatched." author="Edo State Government" role="Digital Transformation Team" data-id="element-292" />
            <TestimonialCard quote="The business plan they crafted was instrumental in securing our seed funding. Highly professional and strategic." author="Tech Startup Founder" role="Technology Sector" data-id="element-293" />
            <TestimonialCard quote="Our e-commerce platform has transformed our business. Sales increased 300% in the first quarter." author="Myma Foods" role="Food & Beverage" data-id="element-294" />
          </div>
        </div>
      </section>

      {/* Industries Served */}
      <section className="py-12 sm:py-20" data-id="element-295">
        <div className="max-w-7xl mx-auto px-4 sm:px-6" data-id="element-296">
          <div className="text-center mb-12 sm:mb-16" data-id="element-297">
            <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-298">
              Industries We Serve
            </h2>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6" data-id="element-299">
            <IndustryCard icon="🏛️" name="Government & Public Sector" data-id="element-300" />
            <IndustryCard icon="💼" name="Financial Services" data-id="element-301" />
            <IndustryCard icon="🏥" name="Healthcare" data-id="element-302" />
            <IndustryCard icon="📚" name="Education" data-id="element-303" />
            <IndustryCard icon="🛒" name="E-commerce & Retail" data-id="element-304" />
            <IndustryCard icon="🏭" name="Manufacturing" data-id="element-305" />
            <IndustryCard icon="⚡" name="Energy & Utilities" data-id="element-306" />
            <IndustryCard icon="🌾" name="Agriculture & Agritech" data-id="element-307" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-20 bg-gradient-to-br from-blue-900 to-slate-900 text-white" data-id="element-308">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center" data-id="element-309">
          <h2 className="text-3xl sm:text-4xl font-black mb-6" data-id="element-310">
            Join Our Growing List of Satisfied Clients
          </h2>
          <p className="text-lg sm:text-xl text-slate-300 mb-10" data-id="element-311">
            Let's discuss how we can help transform your business
          </p>
          <a href="/contact" className="inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 bg-white text-blue-900 hover:bg-slate-100 rounded-lg font-bold text-base sm:text-lg transition-all duration-300 hover:scale-105" data-id="element-312">
            Become a Client
            <Building2 className="w-5 h-5" data-id="element-313" />
          </a>
        </div>
      </section>
    </div>;
}
function FeaturedClientCard({
  client
}: {
  client: any;
}) {
  return <div className="group p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-blue-200" data-id="element-314">
      <div className="text-6xl mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-315">
        {client.logo}
      </div>
      <h3 className="text-xl font-black text-slate-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-316">
        {client.name}
      </h3>
      <div className="text-sm text-slate-600 font-semibold" data-id="element-317">
        {client.sector}
      </div>
    </div>;
}
function ClientLogoCard({
  client
}: {
  client: any;
}) {
  return <div className="group p-6 bg-slate-50 hover:bg-white rounded-xl transition-all duration-300 hover:shadow-lg text-center" data-id="element-318">
      <div className="text-4xl mb-2 group-hover:scale-110 transition-transform duration-300" data-id="element-319">
        {client.logo}
      </div>
      <div className="text-xs font-bold text-slate-700 group-hover:text-blue-600 transition-colors" data-id="element-320">
        {client.name}
      </div>
    </div>;
}
function TestimonialCard({
  quote,
  author,
  role
}: {
  quote: string;
  author: string;
  role: string;
}) {
  return <div className="p-6 sm:p-8 bg-white rounded-2xl shadow-lg" data-id="element-321">
      <div className="text-4xl mb-4" data-id="element-322">💬</div>
      <p className="text-slate-700 leading-relaxed mb-6 italic" data-id="element-323">"{quote}"</p>
      <div className="border-t border-slate-200 pt-4" data-id="element-324">
        <div className="font-black text-slate-900" data-id="element-325">{author}</div>
        <div className="text-sm text-slate-600" data-id="element-326">{role}</div>
      </div>
    </div>;
}
function IndustryCard({
  icon,
  name
}: {
  icon: string;
  name: string;
}) {
  return <div className="p-6 bg-slate-50 hover:bg-white rounded-xl transition-all duration-300 hover:shadow-lg text-center group" data-id="element-327">
      <div className="text-5xl mb-3 group-hover:scale-110 transition-transform duration-300" data-id="element-328">
        {icon}
      </div>
      <div className="font-bold text-slate-800 group-hover:text-blue-600 transition-colors" data-id="element-329">
        {name}
      </div>
    </div>;
}